import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertDescription,
  Button,
} from '@chakra-ui/react';
import { t } from '#i18n';

export const PermissionsRequiredWarning = ({
  message,
  variant,
  permissionsGrantUrl,
  buttonProps = {},
  ...props
}) => (
  <Alert
    status="warning"
    fontSize="sm"
    borderRadius="md"
    borderColor="orange.500"
    paddingY={3}
    paddingX={4}
    variant={variant}
    {...props}
  >
    {variant === 'subtle' && <AlertIcon role="img" color="orange.500" />}
    <AlertDescription>
      {message}
      <Button
        display="block"
        size="sm"
        color="orange.500"
        variant="link"
        onClick={() => window.open(permissionsGrantUrl, '_blank')}
        marginTop={1}
        {...buttonProps}
      >
        {t('alerts.permissionsRequired.callToAction')}
      </Button>
    </AlertDescription>
  </Alert>
);
